import type { GetMeUserResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useUser() {
  const query = useQuery<GetMeUserResponse>({
    queryFn: () => apiClient.url("/users/me").get().json(),
    queryKey: ["user"],
    staleTime: Infinity,
  });

  const currentProject = query.data?.projects.find(
    (project) => project.id === query.data.currentProjectId,
  );

  return {
    ...query,
    currentProject,
    websiteUrl: query.data?.websiteUrl,
  };
}
